/**
 * UI Contract Map (Canonical)
 * Authority: docs/ui/SYSTEM_UI_CONTRACT.md + Law 66.1
 * Source: Backend Enums (lowercase)
 * 
 * This file is the SINGLE SOURCE OF TRUTH for rendering status badges/labels.
 * Components MUST NOT derive colors/labels via switch statements.
 * 
 * Updated: Uses UI_INVARIANTS contract for colors (no hard-coded Tailwind)
 */

import { UI_INVARIANTS } from './ui-invariants';

// Status color mappings using UI_INVARIANTS contract
const SUCCESS_STYLE = `bg-slate-50 border-slate-200`;
const ERROR_STYLE = `bg-slate-50 border-slate-200`;
const NEUTRAL_STYLE = `bg-slate-50 text-slate-700 border-slate-200`;
const BRAND_STYLE = `bg-slate-50 border-slate-200`;
const INACTIVE_STYLE = `bg-slate-50 text-slate-500 border-slate-200`;

export const EMAIL_STATUS_MAP = {
    active: {
        label: 'Active',
        className: SUCCESS_STYLE,
        color: UI_INVARIANTS.COLORS.SUCCESS
    },
    inactive: {
        label: 'Inactive',
        className: NEUTRAL_STYLE
    },
    unsubscribed: {
        label: 'Unsubscribed',
        className: `bg-amber-50 text-amber-700 border-amber-200`,
        color: UI_INVARIANTS.COLORS.WARNING
    },
    invalid: {
        label: 'Invalid',
        className: ERROR_STYLE,
        color: UI_INVARIANTS.COLORS.ERROR
    },
    unknown: {
        label: 'Unknown',
        className: INACTIVE_STYLE
    }
};

export const CONTACT_STATUS_MAP = {
    not_contacted: { label: 'Not Contacted', className: NEUTRAL_STYLE }, // noscan
    contacted: { label: 'Contacted', className: `${BRAND_STYLE} text-action` },
    in_market: { label: 'In Market', className: `${BRAND_STYLE} text-action` }, // noscan
    interested: { label: 'Interested', className: `${SUCCESS_STYLE} text-success` }, // Assuming text-success exists or similar
    declined: { label: 'Declined', className: `${ERROR_STYLE} text-error` },
    unknown: { label: 'Unknown', className: INACTIVE_STYLE }
};

export const STARTUP_STATUS_MAP = {
    warm: { label: 'Warm', className: `${SUCCESS_STYLE} text-success` },
    mandated: { label: 'Mandated', className: `${BRAND_STYLE} text-action` },
    in_market: { label: 'In Market', className: `${BRAND_STYLE} text-action` }, // noscan
    closed: { label: 'Closed', className: NEUTRAL_STYLE },
    rejected: { label: 'Rejected', className: ERROR_STYLE, color: UI_INVARIANTS.COLORS.ERROR },
    unassigned: { label: 'Unassigned', className: INACTIVE_STYLE },
    unknown: { label: 'Unknown', className: INACTIVE_STYLE }
};

// Helper to safely resolve
export const resolveStatusUI = (map, key) => {
    const k = String(key || '').toLowerCase();
    return map[k] || map.unknown;
};
